import { Link } from 'react-router-dom';
import logo from '../../../assets/images/kaercher-logo.svg';
import { useAnalyticsLinkActivated } from '../../../cross-cutting-concerns/analytics/hooks/useAnalyticsLinkActivated';
import { AnalyticsLink } from '../../../cross-cutting-concerns/analytics/interfaces/Analytics.types';
import { StyledPublicHeader } from './PublicHeader.styles';

export const PublicHeader = (): JSX.Element => {
  const analyticsLinkActivated = useAnalyticsLinkActivated();

  return (
    <StyledPublicHeader className="app-header">
      <Link
        to={'/'}
        onClick={(): void => {
          analyticsLinkActivated({
            linkName: AnalyticsLink.HEADER_LOGO,
          });
        }}
      >
        <img src={logo} alt="logo" />
      </Link>
    </StyledPublicHeader>
  );
};
